// extracted by mini-css-extract-plugin
export var card = "_lf-5";
export var cardSelected = "_lf-4";
export var image = "_lf-3";
export var modal = "_lf-0";
export var modalContent = "_lf-1";
export var table = "_lf-2";